
import { Component, Watch, mixins } from 'nuxt-property-decorator'
import Mixin from '@/mixins'
import { getModule } from 'vuex-module-decorators'
import UserModule from '@/store/user'
import SettingsModule from '@/store/settings'
import { DataPopup } from '@/models/setting'

@Component({
  name: 'ModalNotificationSuccess',
})
export default class ModalNotificationSuccess extends mixins(Mixin) {
  disabled: boolean = false
  get show(): boolean {
    return getModule(SettingsModule, this.$store).isVisibleDialogNotification
  }

  //Get data: email,status,theme,comebackUrl
  get dataPopup(): DataPopup {
    return getModule(SettingsModule, this.$store).dataPopupNotification
  }

  get isAuth(): boolean {
    return getModule(UserModule, this.$store).isAuth
  }

  setIsShow(status: boolean) {
    getModule(SettingsModule, this.$store).showDialogNotification(status)
    return (
      !this.isAuth &&
      (document.location.href = this.dataPopup.comebackUrl
        ? this.dataPopup.comebackUrl
        : document.location.origin + (this.$t('routes.it_jobs_home') as string))
    )
  }

  openExploreMore() {
    return (document.location.href =
      document.location.origin + (this.$t('routes.it_jobs_home') as string))
  }

  @Watch('show', { immediate: true, deep: true })
  isShowChanged() {
    return getModule(SettingsModule, this.$store).isVisibleDialogNotification
  }

  textTitleForApplay: string = this.dataPopup.status
    ? 'text.title_notification_success_popup'
    : 'common.error'
  descriptionForApplay: string = this.dataPopup.status
    ? 'text.description_notification_success_popup'
    : 'text.cv_applied'
}
